import secondaryComponents from "../../..";
import Images from "../../../../../assets/images";
import { useProductList } from "./useProductList";

export const ProductList = ({
  productList = [],
  formData = {},
  autoScrollRef,
  setFormData = () => {},
}) => {
  const { instance } = useProductList({ productList, formData, setFormData });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <secondaryComponents.TableHelper
      getTableProps={getTableProps}
      getTableBodyProps={getTableBodyProps}
      headerGroups={headerGroups}
      rows={rows}
      prepareRow={prepareRow}
      autoScrollRef={autoScrollRef}
      handleScroll={true}
    >
      <div className="text-center mt-5 mb-5">
        <img src={Images.productsEmptyState} width="250px" alt="" />
        <h4 className="font-weight-semibold text-center mt-4">
          Please select a store to proceed with storefront creation
        </h4>
      </div>
    </secondaryComponents.TableHelper>
  );
};
